import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const chartOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'bottom',
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      }
    },
    y: {
      grid: {
        borderDash: [10, 8],
        color: "#eee",
        
      }
    }
  }
};
const GenericChart = ({type, options, data, xAxis=[], dataPoints=[], label, additionalDataSetOptions={}}) => {
  let _data = {}, _options={...chartOptions, ...options};
  if(data){
    _data = data;
  }else{
    _data = {
      labels: xAxis,
      datasets: [{
        label: label || '',
        data: [...dataPoints],
        ...additionalDataSetOptions
      }]
    };
  }
  return type ? (
    <Chart
      options={_options}
      type={type}
      data={_data}
    />
  ) : null;
}
 
export default React.memo(GenericChart);
